<template>
  <div>
    <h2 class="title">Last edited pages</h2>
    <el-table :data="recentPages" style="width: 100%">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column label="Title" width="400">
        <template slot-scope="scope" class="pull-right">
          <router-link
            v-if="getLinkForPage(scope.row)"
            class="page-link"
            tag="el-link"
            :to="getLinkForPage(scope.row)"
          >
            {{ scope.row.title }}
          </router-link>
          <span v-else>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Hidden">
        <template slot-scope="scope" class="pull-right">
          <i
            v-if="scope.row.is_hidden"
            class="icon el-icon-circle-check true"
            title="Yes"
          />
          <i v-else class="icon el-icon-circle-close false" title="No" />
        </template>
      </el-table-column>
      <el-table-column
        prop="modified"
        :formatter="formatDate('modified')"
        label="Modified date"
      />
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    recentPages: Array
  },
  methods: {
    getLinkForPage(page) {
      const routeForModelName = {
        FlatPage: 'Edit Page'
      }
      const routeName = routeForModelName[page.model_name]
      if (!routeName) return
      return {
        name: routeName,
        params: {
          id: page.id
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 24px;
  margin-top: 44px;
}
.page-link {
  font-weight: 700;
}
</style>
